module.exports = __webpack_public_path__ + "img/Banner1.194e0e77.gif";